<template>
    <div class="container-table-simulations scroll-color">
        <ui-simulation-financial-analysis :data="simulation" />
        <ui-simulation-capture-analysis  :monthly="true" />
        <ui-simulation-capture-analysis :monthly="false" />
    </div>
</template>

<script>
import { uiSimulationCaptureAnalysis, uiSimulationFinancialAnalysis } from '@/components/ui-facilita/sales/simulation'

import { mapGetters } from 'vuex'

export default {
    name: 'ui-vertical-financial-analysis',

    components: {
        uiSimulationFinancialAnalysis,
        uiSimulationCaptureAnalysis
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.dispatch('simulation/setSimulation', to.params.id)
        })
    },

    props: {
        id: {
            type: [Number, String],
            required: true
        }
    },

    computed: {
        ...mapGetters('simulation', {
            simulation: 'getSimulation',
            staticSeries: 'getStaticSeries',
            series: 'getSeries',
        })
    },

    created() {
        document.addEventListener('keydown', (event) => {
            if (event.key === "Escape" || event.keyCode === 27) {
                const event = new CustomEvent('iframe--request-modal')
                window.parent.document.dispatchEvent(event)
            }
        })

        const intervalId = setInterval(() => {
            const frameChat = document.querySelector('.octa-widget-v2')

            if (frameChat) {
                frameChat.style.display = 'none'
                // Parar o intervalo
                clearInterval(intervalId)
            }
        }, 10)
    }
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
